export const GET_CURRENT_LOCATION ="GET_CURRENT_LOCATION";
export const SET_CURRENT_LOCATION ="SET_CURRENT_LOCATION";
export const GET_CURRENT_UNIT = "GET_CURRENT_UNIT";
export const SET_CURRENT_UNIT="SET_CURRENT_UNIT";
